import { render, staticRenderFns } from "./MercadoPagoDialog.vue?vue&type=template&id=705d87cf&scoped=true&"
import script from "./MercadoPagoDialog.vue?vue&type=script&lang=js&"
export * from "./MercadoPagoDialog.vue?vue&type=script&lang=js&"
import style0 from "./MercadoPagoDialog.vue?vue&type=style&index=0&id=705d87cf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705d87cf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VDialog,VIcon,VProgressLinear})
